<template>
  <div class="status-group-chips">
    <sChip
      v-for="(suppliersRequestStatistic, suppliersRequestStatisticIndex) in items"
      :key="suppliersRequestStatisticIndex"
      :background="suppliersRequestStatisticColor[suppliersRequestStatistic.status]"
      color="var(--color-black)"
      data-qa="status">
      <sTooltip
        :border="false"
        :content="$t(`groupOfAccreditation.status.${suppliersRequestStatistic.status}`)"
        :open-delay="300"
        placement="bottom"
        type="white">
        <div>{{ suppliersRequestStatistic.count }}</div>
      </sTooltip>
    </sChip>
  </div>
</template>
<script>
import { accreditationStatusColor } from 'helpers/accreditationStatusColor'

export default {
  name: 'groupOfAccreditationStateChips',
  data() {
    return {
      suppliersRequestStatisticColor: accreditationStatusColor
    }
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
}
</script>
<style scoped lang="scss">
.status-group-chips {
  gap: 4px;
  display: flex;
  flex-direction: row;
  margin: auto 0;
}
</style>
